import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../utilities/i18n';

export default function BackButton({ url, className = '', children, href = null }) {
    const i18n = useI18n();

    const classes = `${className} inline-flex items-center space-x-2 underline hover:text-green`

    const contents = () => <>
        <svg width="13" height="13" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 5.688H3.112l4.542-4.542L6.5 0 0 6.5 6.5 13l1.146-1.146-4.534-4.541H13z" fill="currentColor" fillRule="evenodd"/>
        </svg>
        <span>{ children || i18n.forms.back }</span>
    </>

    if (href) {
        return <a className={ classes } href={ href }>
            { contents() }
        </a>
    }

    return <Link className={classes} to={ url }>
        { contents() }
    </Link>
}
